import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import GameSceneBase from './GameSceneBase';
import { GameTimer } from '../../display/ui/games/GameTimer';
import { OnboardingPointer } from '../../display/ui/OnboardingPointer';

const PIECES = [
  {
    id: 'cornerLarge',
    spriteKey: 'soap_bit_corner_large',
    shapeArray: [
      [1, 1, 1],
      [1, 0, 0],
      [1, 0, 0],
    ],
  },
  {
    id: 'leftCornerSmall',
    spriteKey: 'soap_bit_left_corner_small',
    shapeArray: [
      [1, 0],
      [1, 1],
    ],
  },
  {
    id: 'straightLong',
    spriteKey: 'soap_bit_straight_long',
    shapeArray: [[1, 1, 1, 1]],
  },
  {
    id: 'cross',
    spriteKey: 'soap_bit_cross',
    shapeArray: [
      [0, 1, 0],
      [1, 1, 1],
      [0, 1, 0],
    ],
  },
  {
    id: 'rightCornerSmall',
    spriteKey: 'soap_bit_right_corner_small',
    shapeArray: [
      [1, 1],
      [0, 1],
    ],
  },
  {
    id: 'soapSquare',
    spriteKey: 'soap_bit_square',
    shapeArray: [
      [1, 1],
      [1, 1],
    ],
  },
];

// const TEST_MOVES = {
//   soap_bit_corner_large: { x: 762, y: 242 },
//   soap_bit_cross: { x: 858, y: 242 },
//   soap_bit_left_corner_small: { x: 786, y: 266 },
//   soap_bit_right_corner_small: { x: 930, y: 218 },
//   soap_bit_square: { x: 930, y: 314 },
//   soap_bit_straight_long: { x: 786, y: 338 },
// };

const GAME_TIME_LIMIT = 60000;
//const GAME_TIME_LIMIT = 2000;

export default class EndlessSoapBar extends GameSceneBase {
  constructor() {
    super({ key: KEYS.EndlessSoapBar, active: false });
  }

  create() {
    super.create();
    this.gameRunning = false;
    this.timelimit = GAME_TIME_LIMIT;
    this.input.on('dragstart', this.handleDragStart, this);
    this.input.on('drag', this.handleDragMove, this);
    this.input.on('dragend', this.handleDragEnd, this);

    this.spineBG = this.add.spine(840, 360, 'endless_soap_bar_background', '', true);

    this.gameClock = new GameTimer(this, 550, 0);
    // this.gameClock.setTimePercent(0);
    // set grid properties
    this.gridX = 690;
    this.gridY = 170;
    this.gridColumns = 6;
    this.gridRows = 4;
    this.gridSize = 48;
    this.gridWidth = this.gridColumns * this.gridSize;
    this.gridHeight = this.gridRows * this.gridSize;
    // render grid
    this.gridDisplay = this.add.graphics();
    this.gridDisplay.lineStyle(2, 0xffffff, 0.5);
    for (let x = 0; x <= this.gridColumns; x++) {
      this.gridDisplay.lineBetween(
        this.gridX + x * this.gridSize,
        this.gridY,
        this.gridX + x * this.gridSize,
        this.gridY + this.gridRows * this.gridSize
      );
    }
    for (let y = 0; y <= this.gridRows; y++) {
      this.gridDisplay.lineBetween(
        this.gridX,
        this.gridY + y * this.gridSize,
        this.gridX + this.gridColumns * this.gridSize,
        this.gridY + y * this.gridSize
      );
    }
    this.gridDisplay.visible = false;

    this.onboardingPointer = new OnboardingPointer(this).setDepth(2);

    this.setUpGame();
  }

  setUpGame() {
    this.gameClock.visible = false;
    this.timelimit = GAME_TIME_LIMIT;
    this.playerScore = 0;
    this.spineBG.play('intro', false);
    this.spineBG.once('complete', this.showInstruction, this);
    this.spineBG.on('event', this.handleSpineEvent, this);
  }

  handleSpineEvent(t, e) {
    if (e.data?.name === 'sfx') {
      switch (e.stringValue) {
        case 'page_open':
          this.game.soundController.playSFX('general', 'general_page_open');
          break;
        case 'page_close':
          this.game.soundController.playSFX('general', 'general_page_close');
          break;
        case 'page_popup':
          this.game.soundController.playSFX('general', 'general_popup');
          break;
      }
    }
  }

  showInstruction() {
    super.showInstruction(this.game.copy.get('EndlessSoapBar_instruction'), this.startGame, this);
  }

  startGame() {
    this.gameClock.visible = true;
    this.gameClock.enter();
    this.gameClock.once('complete', () => (this.gameRunning = true), this);
    this.gridDisplay.visible = true;
    let x = 415;
    let image;
    // store the puzzle pices in an array so we can reuse them
    this.puzzlePieces = PIECES.map((piece) => {
      image = this.add.image(0, 0, 'endless_soap_bar', piece.spriteKey).setInteractive();
      image.id = piece.spriteKey;
      image.x = x + image.width * 0.5;
      image.y = 575 - image.height * 0.5;
      x += image.width + 10;
      this.input.setDraggable(image);
      image.shape = piece.shapeArray;
      image.startPos = {
        y: image.y,
        x: image.x,
      };
      return image;
    });
    this.updateOnboardingPositions();
    this.onboardingPointer.enable();

    this.resetPuzzle();
  }

  resetPuzzle() {
    this.gridCells = [];
    while (this.gridCells.length < this.gridRows * this.gridColumns) this.gridCells.push(0);
    this.placedPieces = [];
    this.puzzlePieces.forEach((piece) => {
      piece.x = piece.startPos.x;
      piece.y = piece.startPos.y;
      piece.scale = 1;
      // this.bouncePeice(piece, -1);
    });
  }

  updateOnboardingPositions() {
    this.onboardingPointer.setDragPositions({
      from: this.placedPieces
        ? this.puzzlePieces.filter((p) => this.placedPieces.indexOf(p) < 0)
        : this.puzzlePieces,
      to: [{ x: 840, y: 250 }],
    });
  }

  // =============================================================================================
  // UPDATE METHOD
  // =============================================================================================

  update(t, delta) {
    if (!this.gameRunning) return;

    this.timelimit -= delta;
    this.gameClock.setTimePercent(this.timelimit / GAME_TIME_LIMIT);
    if (this.timelimit < 0) this.finishGame();
  }

  // =============================================================================================
  // DRAG EVENTS
  // =============================================================================================

  handleDragStart(pointer, gameObject) {
    this.removeFromGrid(gameObject);
    this.children.bringToTop(gameObject);
  }

  handleDragMove(pointer, gameObject, dragX, dragY) {
    gameObject.x = dragX;
    gameObject.y = dragY;
  }

  handleDragEnd(pointer, gameObject) {
    const dropped = this.validatePlacement(gameObject);
    if (!dropped) {
      gameObject.x = gameObject.startPos.x;
      gameObject.y = gameObject.startPos.y;
    } else {
      gameObject.x = dropped.x;
      gameObject.y = dropped.y;
      gameObject.setScale(1);
      const gridComplete = this.checkGridComplete();
      if (gridComplete) this.completePuzzle();
    }
    this.bouncePeice(gameObject, -1);

    this.game.soundController.playSFX('endlesssoapbar', 'soap_place');
  }

  bouncePeice(piece, direction, delay) {
    this.tweens.add({
      targets: piece,
      scale: direction > 0 ? 1.1 : 0.9,
      yoyo: true,
      duration: 125,
      delay,
      ease: 'Bounce.easeOut',
      onComplete: () => (piece.scale = 1),
    });
  }

  // =============================================================================================
  // GRID PLACEMENT VALIDATION
  // =============================================================================================

  validatePlacement(piece) {
    // get snap position
    const px = piece.x - piece.width * 0.5;
    const py = piece.y - piece.height * 0.5;
    const snapX = this.gridX + Math.round((px - this.gridX) / this.gridSize) * this.gridSize;
    const snapY = this.gridY + Math.round((py - this.gridY) / this.gridSize) * this.gridSize;
    // make sure piece is within bounds
    if (snapX < this.gridX || snapX + piece.width > this.gridX + this.gridWidth) return false;
    if (snapY < this.gridY || snapY + piece.height > this.gridY + this.gridHeight) return false;
    // attempt to add the piece to the grid
    if (!this.addToGrid(piece)) return false;
    // if we make it this far, the position is valid so return it
    return { x: snapX + piece.width * 0.5, y: snapY + piece.height * 0.5 };
  }

  addToGrid(piece) {
    // ignore if is already added
    if (this.placedPieces.indexOf(piece) >= 0) return;
    // grab the base grid x/ y
    const px = piece.x - piece.width * 0.5;
    const py = piece.y - piece.height * 0.5;
    const gx = Math.round((px - this.gridX) / this.gridSize);
    const gy = Math.round((py - this.gridY) / this.gridSize);
    // create an empty array for where we would like to fill a cell
    const desiredCells = [];
    // loop through the shape array of the puzzle peice
    for (let y = 0; y < piece.shape.length; y++) {
      for (let x = 0; x < piece.shape[y].length; x++) {
        if (piece.shape[y][x] === 1) {
          //  grab the relative cell position based on positiion in shape array
          const cell = gx + x + this.gridColumns * (gy + y);
          // if the relative cell is already occupied, we cannot place the peice here, so we just bail
          if (this.gridCells[cell]) return false;
          // otherwise add the cell index to the desired array
          desiredCells.push(cell);
        }
      }
    }
    // if we get this far, placement is valid so populate our desired cells and return valid
    desiredCells.forEach((cell) => (this.gridCells[cell] = 1));

    // add to placed pices
    this.placedPieces.push(piece);
    this.updateOnboardingPositions();

    return true;
  }

  removeFromGrid(piece) {
    if (this.placedPieces.indexOf(piece) >= 0) {
      this.placedPieces.splice(this.placedPieces.indexOf(piece), 1); // grab the base grid x/ y

      const px = piece.x - piece.width * 0.5;
      const py = piece.y - piece.height * 0.5;

      const gx = Math.round((px - this.gridX) / this.gridSize);
      const gy = Math.round((py - this.gridY) / this.gridSize);
      // loop through the shape array of the puzzle peice
      for (let y = 0; y < piece.shape.length; y++) {
        for (let x = 0; x < piece.shape[y].length; x++) {
          if (piece.shape[y][x] === 1) {
            //  grab the relative cell position based on positiion in shape array
            const cell = gx + x + this.gridColumns * (gy + y);
            // clear out the relative cell
            this.gridCells[cell] = 0;
          }
        }
      }
      this.updateOnboardingPositions();
    }
  }

  checkGridComplete() {
    // console.log(this.gridCells);
    return this.gridCells.findIndex((c) => c !== 1) < 0;
  }

  completePuzzle() {
    // this.testTime.remove();
    this.puzzlePieces.forEach((p) => p.destroy());
    this.finishGame();

    this.time.delayedCall(1500, this.resetPuzzle, null, this);
  }

  // =============================================================================================
  // FINISHING GAME
  // =============================================================================================

  finishGame() {
    this.onboardingPointer.disable();
    // stop the game from running, calculate results and then trigger close animations
    this.gameRunning = false;
    this.gameClock.exit();
    this.game.soundController.stopAllSFX();
    let stars = 0;

    if (this.timelimit <= 0) {
      console.log(this.timelimit);
      stars = 0;
    }

    if (this.timelimit > 1) {
      console.log(this.timelimit);
      stars = 1;
    }

    if (this.timelimit > 20000) {
      console.log(this.timelimit);
      stars = 2;
    }

    if (this.timelimit > 40000) {
      console.log(this.timelimit);
      stars = 3;
    }

    const didWin = stars >= 1;

    this.closeGame(didWin, stars);
  }

  closeGame(win, stars) {
    this.game.soundController.stopMusic('music');
    // let the background play out, once complete we trigger the game end screen
    this.spineBG.once('complete', () => this.showEndGameScreen(win, stars));
    this.spineBG.play(win ? 'win' : 'lose');

    this.gridDisplay.visible = false;
    this.puzzlePieces.forEach((piece, index) => {
      piece.setOrigin(0.5, 1);
      piece.x += piece.width * 0.5;
      piece.y += piece.height;
      this.tweens.add({
        targets: piece,
        scale: 0,
        duration: 250,
        delay: 50 * index,
        onComplete: () => piece.destroy(),
        onCompleteScope: this,
      });
    });
    this.game.soundController.playSFX('general', win ? 'general_success' : 'general_fail', {
      delay: 1.2,
    });
    this.game.soundController.playSFX('endlesssoapbar', win ? 'soap_success' : 'soap_fail_1', {
      delay: 1.5,
    });
    this.game.soundController.playSFX('endlesssoapbar', win ? null : 'soap_fail_2', { delay: 2.2 });
  }

  restartGame() {
    this.setUpGame();
  }

  shutdown() {
    this.game.soundController.stopAllSFX();
    super.shutdown();
    this.game.unloadGame(KEYS.EndlessSoapBar);
  }
}
